import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


import Dialog from '../../services/Dialogs'


const ModalSubirFichaRecibo = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, registro } = params


const dialog = new Dialog();

const [ envio_server, setSeEnvio ] = useState<boolean>(false)

const enviarFormulario = async (event:any) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ``
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update( `subir_recibo_pago/${registro.uuid}` , { archivo : base64.split(',')[1] })

        if(res_){
          toast.success('Consulta_correcta')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}


  const [file, setFile] = useState<any>(null);
  const [base64, setBase64] = useState<any>(null);

  const handleFileChange = (event:any) => {
    const selectedFile : any = event.target.files[0];
    if (selectedFile) {
      const reader : any = new FileReader();
      reader.readAsDataURL(selectedFile);
      reader.onload = function () {
        setBase64(reader.result);
      };
      reader.onerror = function (error:any) {
        console.error('Error converting file:', error);
      };
    }
  };

    

  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Subir Ficha de Recibo</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        <small>Descripción</small>
        <h4>{registro.descripcion_registro}</h4>

        <small>Fecha del Movimiento</small>
        <h4>{registro.fecha_movimiento}</h4>

        <small>Concepto</small>
        <h4>{registro.tipo_descripcion}</h4>
 
          {
            // JSON.stringify(base64)
          }

          <input type="file" onChange={handleFileChange} />



        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" disabled={!base64} onClick={enviarFormulario} type="button">Ok</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalSubirFichaRecibo;